import Vue from "vue";
import ElementUI from "element-ui";
import "element-ui/lib/theme-chalk/index.css";
import App from "./App.vue";
import router from "./router";
import api from "./api/client";

Vue.use(ElementUI);
Vue.config.productionTip = false;
// 便于模板里调用：this.$api
Vue.prototype.$api = api;

new Vue({
  router,
  render: (h) => h(App),
}).$mount("#app");
